<template>
  <div>
    <p class="tips">{{$t('APP-FIELD-0112')}}
      <span class="policy-tips" @click="policyShow = true"> {{$t('APP-FIELD-0113')}}</span> {{$t('APP-FIELD-0114')}}
      <span>{{$t('APP-FIELD-0115')}}</span> {{$t('APP-FIELD-0116')}}
    </p>
    <privacy-policy v-model="policyShow"/>
  </div>
</template>

<script>
  import PrivacyPolicy from './PrivacyPolicy';

  export default {
  name: 'PrivacyLine',
  components: {
    PrivacyPolicy,
  },
  data() {

    return {
      policyShow: false,
    };
  },

}
</script>

<style lang="scss" scoped>
  .tips {
    font-family: Nunito-Bold;
    font-size: 16px;
    color: #2E2E2E;
    letter-spacing: 0;
    line-height: 24px;
    margin: 21px 0 40px;

    .policy-tips {
      font-family: Nunito-Bold;
      font-size: 16px;
      color: #2184D3;
      letter-spacing: 0;
      line-height: 19px;
      cursor: pointer;
    }
  }
</style>
